import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  changeCourseListLoading: false,
  changeCourseListSuccess: null,
  changeCourseListError: '',
}

export const changeCourseSlice = createSlice({
  name: 'changeCourses',
  initialState,
  reducers: {
    setChangeCourseListLoading: (state, action) => {
      state.changeCourseListLoading = true;
      state.changeCourseListSuccess = null;
      state.changeCourseListError = '';
    },
    setChangeCourseListSuccess: (state, action) => {
      state.changeCourseListLoading = false;
      state.changeCourseListSuccess = action.payload;
      state.changeCourseListError = '';
    },
    setChangeCourseListError: (state, action) => {
      state.changeCourseListLoading = false;
      state.changeCourseListSuccess = null;
      state.changeCourseListError = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setChangeCourseListLoading, setChangeCourseListSuccess, setChangeCourseListError } = changeCourseSlice.actions

export default changeCourseSlice.reducer;